import { render, staticRenderFns } from "./publicCarmi.vue?vue&type=template&id=a5a384d8&scoped=true&"
import script from "./publicCarmi.vue?vue&type=script&lang=js&"
export * from "./publicCarmi.vue?vue&type=script&lang=js&"
import style0 from "./publicCarmi.vue?vue&type=style&index=0&id=a5a384d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a384d8",
  null
  
)

export default component.exports